import { InjectionToken } from '@angular/core';

export const LOCATION_URL = new InjectionToken<string>('LOCATION_V2_URL');
